// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  'Visit the guide for more information: ',
  'https://vite-ruby.netlify.app/guide/rails'
);

// Example: Load Rails libraries in Vite.
//
import * as Turbo from '@hotwired/turbo';
Turbo.start();
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Bootstrap's needs JavaScript for a few things...
// https://getbootstrap.com/docs/5.2/getting-started/javascript/
import * as Bootstrap from 'bootstrap';

// Enable Bootstrap's tooltips. Re-run on every Turbo navigation (turbo:load
// fires on the initial load too) so tooltips on pages swapped in by Turbo
// Drive still get initialized. getOrCreateInstance avoids duplicate instances.
function initTooltips() {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(function (tooltipTriggerEl) {
      Bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
    });
}
document.addEventListener('turbo:load', initTooltips);

// Dispose all tooltip instances before Turbo caches the page so stale
// instances don't leak into the snapshot or accumulate across visits.
document.addEventListener('turbo:before-cache', function () {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
    Bootstrap.Tooltip.getInstance(el)?.dispose();
  });
});

import '../controllers';

// Initialize sorttable with Turbo support and sort state persistence
(function () {
  let sorttableReady = false;
  let pendingTables = [];
  let restoringState = false; // Flag to prevent saving during restore

  // Generate a stable key for a table based on its location in the page
  function getTableKey(table) {
    // Use data attribute if present, otherwise use the closest ID or path-based key
    if (table.dataset.sorttableKey) {
      return `sorttable_${table.dataset.sorttableKey}`;
    }
    // Use the current page path + table index as fallback
    const tables = document.querySelectorAll('table.sortable');
    const index = Array.from(tables).indexOf(table);
    return `sorttable_${window.location.pathname}_${index}`;
  }

  // Save sort state to sessionStorage
  function saveSortState(table, columnIndex, direction) {
    if (restoringState) return; // Don't save during restore
    const key = getTableKey(table);
    sessionStorage.setItem(
      key,
      JSON.stringify({ columnIndex, direction })
    );
  }

  // Restore sort state from sessionStorage
  function restoreSortState(table) {
    const key = getTableKey(table);
    const saved = sessionStorage.getItem(key);
    if (saved) {
      try {
        const { columnIndex, direction } = JSON.parse(saved);
        const headers = table.tHead?.rows[0]?.cells;
        if (headers && headers[columnIndex]) {
          const header = headers[columnIndex];
          restoringState = true;
          // Trigger a click to sort (ascending)
          header.click();
          // If we need descending (reverse), click again after a frame
          // to ensure the first sort has completed
          if (direction === 'desc') {
            requestAnimationFrame(() => {
              header.click();
              restoringState = false;
            });
          } else {
            restoringState = false;
          }
        }
      } catch (e) {
        // Invalid saved state, ignore
        sessionStorage.removeItem(key);
        restoringState = false;
      }
    }
  }

  // Add click listeners to track sort state
  function addSortStateTracking(table) {
    const headers = table.tHead?.rows[0]?.cells;
    if (!headers) return;

    Array.from(headers).forEach((header, index) => {
      // Skip headers marked as no-sort
      if (header.className.match(/\bsorttable_nosort\b/)) return;

      header.addEventListener('click', () => {
        // Determine direction based on class after click
        // sorttable adds sorttable_sorted for ascending, sorttable_sorted_reverse for descending
        setTimeout(() => {
          let direction = 'asc';
          if (header.className.includes('sorttable_sorted_reverse')) {
            direction = 'desc';
          }
          saveSortState(table, index, direction);
        }, 0);
      });
    });
  }

  // Function to initialize a table
  function initTable(table) {
    if (
      sorttableReady &&
      typeof sorttable !== 'undefined' &&
      sorttable.makeSortable
    ) {
      // Check if already initialized by looking for the columnindex property
      if (table.tHead && table.tHead.rows[0]) {
        const firstHeader = table.tHead.rows[0].cells[0];
        const alreadyInitialized =
          typeof firstHeader.sorttable_columnindex !== 'undefined';

        if (!alreadyInitialized) {
          sorttable.makeSortable(table);
        }

        // Always add tracking and restore, even if already initialized
        // Check if we've already added our tracking by looking for a marker
        if (!table.dataset.sortStateTracking) {
          table.dataset.sortStateTracking = 'true';
          addSortStateTracking(table);
          restoreSortState(table);
        }
      }
    } else {
      // Queue for later
      pendingTables.push(table);
    }
  }

  // Process pending tables
  function processPending() {
    if (sorttableReady && pendingTables.length > 0) {
      pendingTables.forEach((table) => {
        if (document.contains(table)) {
          // Make sure table is still in DOM
          initTable(table);
        }
      });
      pendingTables = [];
    }
  }

  // Check when sorttable is ready
  function checkSorttable() {
    if (typeof sorttable !== 'undefined' && sorttable.makeSortable) {
      sorttableReady = true;
      processPending();
    } else {
      setTimeout(checkSorttable, 10);
    }
  }

  // Start checking for sorttable
  checkSorttable();

  // Initialize on Turbo navigation
  document.addEventListener('turbo:load', () => {
    // Find all sortable tables
    const tables = document.querySelectorAll('table.sortable');
    tables.forEach((table) => initTable(table));
  });

  // Also handle Turbo frame updates
  document.addEventListener('turbo:frame-load', () => {
    // Find sortable tables in frames
    const tables = document.querySelectorAll('table.sortable');
    tables.forEach((table) => initTable(table));
  });
})();
